import _cookie from "js-cookie";
export const cookies = _cookie;
export { getCookie } from "./getCookie/getCookie.js";
